export enum ProgressStatus {
  Unseen = 0,
  InProgress,
  Complete,
  Skipped
}
